import { injectable } from 'tsyringe'
import { QuickGuideReportApiRepository } from '@/app/repositories/api/QuickGuideReportApiRepository'
import { QuickGuideReport, Export } from '@/domain/entities/QuickGuideReport'

@injectable()
export class QuickGuideReportPresenter {
  private repository: QuickGuideReportApiRepository

  constructor(repository: QuickGuideReportApiRepository) {
    this.repository = repository
  }

  public loadQuickGuideReport(params: Object): Promise<QuickGuideReport> {
    return this.repository.getAll(params)
  }
  public loadExport(params: Object): Promise<Export> {
    return this.repository.getExport(params)
  }
}
